import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const FooterContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-start;

	padding-top: 40px;
	padding-bottom: 40px;
	border-bottom: 1px solid #e8edf1; /* @mystic in less */
	max-width: 1160px;
	margin: 0 auto;
`;

export const Column = styled.div`
	padding: 0 15px;
	margin-bottom: 30px;

	@media(max-width: 375px) {
		width: 100%;
	}

	@media (min-width: 375px) and (max-width: 740px) {
		width: 50%;
	}

`;

export const ColumnTitle = styled.h3`
	font-weight: 600;
	font-size: 16px;
	color: ${getColor('gray')};
	letter-spacing: 0;
	line-height: 21px;

	margin-top: 0;
	margin-bottom: 10px;
`;

export const StyledLink = styled.a`
	display: block;
	text-decoration: none;
	color: ${getColor('gray')};
	letter-spacing: 0px;
	line-height: 21px;
	margin-top: 5px;

	&:hover, &:focus, &:active {
		color: ${getColor('darkTeal')};
		text-decoration: none;
	}

	svg {
		margin-right: 11px;
	}
`;

export const FooterFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding-top: 25px;
	padding-bottom: 25px;

	max-width: 1160px;
	margin: 0 auto;
	padding-left: 16px;
	padding-right: 16px;

	@media (min-width: 375px) {
		padding-left: 24px;
		padding-right: 24px;
	}

	@media (min-width: 600px) {
		padding-left: 32px;
		padding-right: 32px;
	}
`;

export const Copyright = styled.div`
	line-height: 1.4;
	text-align: right;
	color: ${getColor('shuttleGray')};

	@media(max-width: 600px) {
		max-width: 128px;
	}
`;

export const BackToTop = styled.a`
	display: block;

	background-color: ${getColor('porcelain')};

	text-align: center;
	font-weight: 600;
	font-size: 12px;
	color: ${getColor('cuttySark')};
	letter-spacing: 3px;

	text-transform: uppercase;
	text-decoration: none;

	padding-top: 14px;
	padding-bottom: 14px;

	&:hover, &:focus, &:active {
		text-decoration: none;
	}
`;
